<template>
    <v-select 
       :value="selected_eventstatus" 
       v-bind:items="eventstatuscodes"
       item-value="code" 
       item-text="description" 
       :label="label"
       dense 
       :clearable="selection_clearable"
       :disabled="disabled"
       @change="updateData">
    </v-select>
</template>

<script>
export default {
    props: {
        selected_eventstatus: String,
        label: String,
        field: {
            default: 'eventstatuscode',
            required: true,
        },
        selection_clearable:{
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            eventstatuscodes: [],
        }
    },
    created() {
        this.getHwst();
    },
    methods: {
        getHwst() {
            this.$axios.post("ares/json/ares/huov/howz/getHwst.p", {
                header: {
                    token: this.$session.get("ARES"),
                    clientSessionId: this.$session.id(),
                    request: "getHwst"
                }
            }).then(res => {
                if (res.data.error) {
                    this.showDialog('error', 'Error', res.data.error.message);
                } else {
                    this.eventstatuscodes = res.data.getHwst;
                }
            })
        },
        updateData(v){
            this.$emit('updateData', { "field": this.field, "value": v === null ? '' : v })
        }
    }
}
</script>

<style scoped>

</style>